window.addEventListener("pageswap", async (e) => {

    // Only run this if an active view transition exists
    if (e.viewTransition) {

        const currentUrl = e.activation.from?.url
        ? new URL(e.activation.from.url)
        : null;
        const targetUrl = new URL(e.activation.entry.url);
        // Going from blog main page to blog post

        if (isBlogMain(currentUrl) && isBlogPost(targetUrl)) {

            const currentTitleLink = document.querySelector(`h2 a[href="${targetUrl.pathname}"]`) ?? null;
            const currentImageLink = document.querySelector(`a[href="${targetUrl.pathname}"] img`) ?? null;

            if(currentTitleLink && currentImageLink){
                setBlogViewAnimation(e,currentTitleLink, currentImageLink);
            }
            
        } else if (isBlogPost(currentUrl) && isBlogMain(targetUrl)) {
            // Going from blog post to blog main page
            const currentTitle= document.querySelector('.news__article-container h1.news__article-title') ?? null;
            const currentImage = document.querySelector('.news__article-container .news__article-image img') ?? null;
            setBlogViewAnimation(e,currentTitle, currentImage);


        } else if (isBlogPost(currentUrl) && isBlogPost(targetUrl)) {
            // Going from one blog post to another
            const currentTitle = document.querySelector(`.posts__others-list-item a[href="${targetUrl.pathname}"] .posts__others-list-item-title`) ?? null;
            const currentImage = document.querySelector(`.posts__others-list-item a[href="${targetUrl.pathname}"] .blog__default-image img`) ?? null;
            setBlogViewAnimation(e,currentTitle, currentImage);
        }
        
    }
    
});

window.addEventListener('pagereveal', async (e) => {

    // If the "from" history entry does not exist, return
    if (!navigation.activation.from) return;

    // Only run this if an active view transition exists
    if (e.viewTransition) {
        const fromUrl = new URL(navigation.activation.from.url);
        const currentUrl = new URL(navigation.activation.entry.url);

        if(isBlogMain(fromUrl) && isBlogPost(currentUrl)) {

            const currentTitle= document.querySelector('.news__article-container h1.news__article-title') ?? null;
            const currentImage = document.querySelector('.news__article-container .news__article-image img') ?? null;
            setBlogViewAnimation(e,currentTitle, currentImage);

        } else if(isBlogPost(fromUrl) && isBlogMain(currentUrl)) {
      
            const currentTitleLink = document.querySelector(`h2 a[href="${fromUrl.pathname}"]`) ?? null;
            const currentImageLink = document.querySelector(`a[href="${fromUrl.pathname}"] img`) ?? null;

            if(currentTitleLink && currentImageLink){
                const currentTitle = currentTitleLink.parentElement;
                const currentImage = currentImageLink.parentElement;
                setBlogViewAnimation(e,currentTitle, currentImage);
            }
            
        }else if(isBlogPost(fromUrl) && isBlogPost(currentUrl)) {
            const currentTitle= document.querySelector('.news__article-container h1.news__article-title') ?? null;
            const currentImage = document.querySelector('.news__article-container .news__article-image img') ?? null;
            setBlogViewAnimation(e,currentTitle, currentImage);
        }   

    }

});

async function setBlogViewAnimation(e,title, image){

    if(title){
        title.style.viewTransitionName = "blog-title";
    }

    if(image){
        image.style.viewTransitionName = "blog-image";
    }  

    await e.viewTransition.finished;

    if(title){
        title.style.viewTransitionName = "";
    }

    if(image){
        image.style.viewTransitionName = "";
    }

}

//function to test if a url path is /blog/ or /blog/page/{number}
function isBlogMain(url) {
  return url.pathname === "/blogs/news";
}

//function that chcks the pathname and if there is text after /blog/ it returns true
function isBlogPost(url) {
  return url.pathname.startsWith("/blogs/news/") && url.pathname.length > 12;
}

// function isHome(url) {
//     return url.pathname === "/";
// }

// function isOwly1(url) {
//     return url.pathname === "/products/owly-1";
// }
